// extracted by mini-css-extract-plugin
module.exports = {"groups":"component-module--groups--2Cf_J","desc":"component-module--desc--qC8XZ"};